const Error = () => {
    return (
    <div className="container" style={{'textAlign': 'center'}}>
        К сожалению на данный момент сайт не поддерживает мобильные устройства. Войдите с ПК !
    </div>
    )
}

export default Error;